module.exports = __webpack_public_path__ + "img/americanexpres.90d5dafd.svg";